<section class="ecb-x-admin-list-section">

  <div class="container-fluid">

    <div class="ecb-x-admin-list-card">

      <div class="d-flex justify-content-between
           align-items-center mb-4 flex-wrap gap-2">

        <div>
          <h1 class="ecb-section-title">
            Short Course Orders
          </h1>

          <p class="ecb-muted mb-0">
            View regular short-course order and payment details.
          </p>
        </div>

        <div class="ecb-order-record-count">
          {{ totalRecords }} Order{{ totalRecords === 1 ? '' : 's' }}
        </div>

      </div>

      <!-- Start Short Course Orders Table -->
<p-table
    [value]="shortCourseOrders"
    [loading]="isLoading"
    [scrollable]="true"
    [tableStyle]="{'min-width': '1280px'}"
    styleClass="ecb-admin-table ecb-short-course-order-table">


        <!-- Header -->
        <ng-template pTemplate="header">

          <tr class="ecb-admin-table-header-row">

            <th class="ecb-admin-table-header" style="width:70px;">
              ID
            </th>

            <th class="ecb-admin-table-header">
              Course
            </th>

            <th class="ecb-admin-table-header">
              Student
            </th>

            <th class="ecb-admin-table-header">
              Amount
            </th>

            <th class="ecb-admin-table-header">
              Payment Status
            </th>

            <th class="ecb-admin-table-header">
              Seats Left
            </th>

            <th class="ecb-admin-table-header">
              Created Date
            </th>

            <th class="ecb-admin-table-header">
              Registration
            </th>

            <th class="ecb-admin-table-header ecb-admin-table-action-header">
              Action
            </th>

          </tr>

        </ng-template>


        <!-- Body -->
        <ng-template pTemplate="body" let-order>

          <tr class="ecb-admin-table-row">


            <!-- ID -->
            <td class="ecb-admin-table-cell">

              <span class="ecb-order-id">
                #{{ orderReferencePrefix }}{{ order.id }}
              </span>

            </td>


            <!-- Course -->
            <td class="ecb-admin-table-cell">

              <div class="ecb-order-course-wrapper">

                <div class="ecb-order-course-title">
                  {{ order.shortCourseTitle || '-' }}
                </div>

                <i class="bi bi-info-circle-fill ecb-order-info-icon" [pTooltip]="courseDetailsTooltip"
                  tooltipPosition="top" [escape]="false">
                </i>

                <ng-template #courseDetailsTooltip>

                  <div class="ecb-order-tooltip-content">

                    <div class="ecb-order-tooltip-row">

                      <span>
                        Start Date
                      </span>

                      <strong>
                        {{ formatCourseDate(order.startDate) }}
                      </strong>

                    </div>


                    <div class="ecb-order-tooltip-row">

                      <span>
                        End Date
                      </span>

                      <strong>
                        {{ formatCourseDate(order.endDate) }}
                      </strong>

                    </div>


                    <div class="ecb-order-tooltip-row">

                      <span>
                        Duration
                      </span>

                      <strong>
                        {{ order.duration || '-' }}
                      </strong>

                    </div>

                  </div>

                </ng-template>

              </div>

            </td>


            <!-- Student -->
            <td class="ecb-admin-table-cell">

              <div class="ecb-order-student-name">
                {{ getStudentName(order) }}
              </div>

              <small>

                <a *ngIf="order.studentEmail" [href]="'mailto:' + order.studentEmail" class="ecb-order-email">

                  {{ order.studentEmail }}

                </a>

                <span *ngIf="!order.studentEmail">
                  -
                </span>

              </small>

            </td>


            <!-- Amount -->
            <td class="ecb-admin-table-cell">

              <span class="ecb-order-amount">

                {{
                order.totalAmount
                | currency:
                (order.currencyCode || 'AUD'):
                'symbol':
                '1.2-2'
                }}

              </span>

            </td>


            <!-- Payment Status -->
            <td class="ecb-admin-table-cell">

              <span class="ecb-order-payment-status" [ngClass]="{
            'ecb-order-payment-paid':
              order.paymentStatus?.toLowerCase() === 'paid',

            'ecb-order-payment-pending':
              !order.paymentStatus ||
              order.paymentStatus?.toLowerCase() === 'pending',

            'ecb-order-payment-failed':
              order.paymentStatus?.toLowerCase() === 'failed',

            'ecb-order-payment-cancelled':
              order.paymentStatus?.toLowerCase() === 'cancelled'
          }">

                {{ order.paymentStatus || 'Pending' }}

              </span>

            </td>


            <!-- Seats Left -->
            <td class="ecb-admin-table-cell">

              <span class="ecb-order-seats">
                {{ order.noOfSeatedLeft }}
              </span>

            </td>


            <!-- Created Date -->
            <td class="ecb-admin-table-cell">

              <span class="ecb-order-created-date">

                {{
                order.createdDate
                ? (order.createdDate | date:'dd/MM/yyyy hh:mm a')
                : '-'
                }}

              </span>

            </td>


            <!-- Registration -->
            <td class="ecb-admin-table-cell">

              <span class="ecb-registration-status" [ngClass]="{
            'ecb-registration-complete':
              hasRegistration(order),

            'ecb-registration-pending':
              !hasRegistration(order)
          }">

                <i class="bi" [ngClass]="{
              'bi-check-circle-fill':
                hasRegistration(order),

              'bi-clock':
                !hasRegistration(order)
            }">
                </i>

                {{
                hasRegistration(order)
                ? 'Registration Complete'
                : 'Pending'
                }}

              </span>

            </td>


            <!-- Action -->
            <td class="ecb-admin-table-cell ecb-admin-table-action-cell">

              <button *ngIf="hasRegistration(order)" type="button"
                class="ecb-admin-table-action-button ecb-admin-table-view-button" (click)="viewRegistration(order)"
                title="View registration">

                <i class="bi bi-eye ecb-admin-table-action-icon">
                </i>

              </button>


              <span *ngIf="!hasRegistration(order)" class="ecb-muted">

                -

              </span>

            </td>

          </tr>

        </ng-template>


        <!-- Empty -->
        <ng-template pTemplate="emptymessage">

          <tr class="ecb-admin-table-row">

            <td colspan="9" class="ecb-admin-table-cell text-center py-5 ecb-muted">

              <i class="fa fa-shopping-cart ecb-order-empty-icon"></i>

              <div>
                No regular short-course orders found.
              </div>

            </td>

          </tr>

        </ng-template>

      </p-table>

<!-- Start Short Course Orders Table Footer -->
<div class="ecb-x-admin-short-course-orders-table-footer">

    <div class="row align-items-center gy-3">

        <!-- Showing Records -->
        <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-short-course-orders-paginator-info">

                Showing
                {{ startRecord }}–{{ endRecord }}
                of {{ totalRecords }} orders

            </div>

        </div>


        <!-- Rows Per Page -->
        <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-short-course-orders-paginator-size">

                <label>
                    Rows per page
                </label>

                <select
                    class="form-select form-select-sm"
                    [(ngModel)]="pageSize"
                    [disabled]="isLoading"
                    (ngModelChange)="onPageSizeChange()">

                    <option [ngValue]="10">10</option>
                    <option [ngValue]="20">20</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>

                </select>

            </div>

        </div>


        <!-- Page Navigation -->
        <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-short-course-orders-paginator-navigation">

                <!-- Previous -->
                <button
                    type="button"
                    class="ecb-x-admin-short-course-orders-page-button"
                    [disabled]="pageNo === 1 || isLoading"
                    (click)="previousPage()">

                    Previous

                </button>


                <!-- Page Numbers -->
                <button
                    type="button"
                    *ngFor="let page of pageNumbers"
                    class="ecb-x-admin-short-course-orders-page-button"
                    [class.ecb-x-admin-short-course-orders-page-active]="pageNo === page"
                    [disabled]="isLoading"
                    [attr.aria-current]="pageNo === page ? 'page' : null"
                    (click)="changePage(page)">

                    {{ page }}

                </button>


                <!-- Next -->
                <button
                    type="button"
                    class="ecb-x-admin-short-course-orders-page-button"
                    [disabled]="pageNo === totalPages || isLoading"
                    (click)="nextPage()">

                    Next

                </button>

            </div>

        </div>

    </div>

</div>
<!-- End Short Course Orders Table Footer -->

      <div *ngIf="errorMessage" class="alert alert-danger mt-3 mb-0">

        <i class="fa fa-exclamation-circle me-2"></i>

        {{ errorMessage }}
      </div>

    </div>
  </div>
</section>

<p-dialog [(visible)]="showRegistrationModal" [modal]="true" [draggable]="false" [resizable]="false"
  [dismissableMask]="true" [showHeader]="false" [style]="{
    width: '1080px',
    maxWidth: '96vw'
  }" styleClass="ecb-rv2-dialog">

  <div class="ecb-rv2-shell" *ngIf="selectedRegistration">


    <!-- ===================================================== -->
    <!-- TOP MODAL HEADER -->
    <!-- ===================================================== -->

    <div class="ecb-rv2-topbar">

      <div>

        <span class="ecb-rv2-top-reference">
          #{{ orderReferencePrefix }}{{
          selectedRegistration.orderId
          || selectedRegistrationOrder?.id
          }}
        </span>

        <h2>
          Booking Registration Details
        </h2>

        <p>
          Review the submitted participant registration information.
        </p>

      </div>


      <button type="button" class="ecb-rv2-close" (click)="showRegistrationModal = false" aria-label="Close">

        <i class="bi bi-x-lg"></i>

      </button>

    </div>


    <!-- ===================================================== -->
    <!-- DOCUMENT -->
    <!-- ===================================================== -->

    <div class="ecb-rv2-document">


      <!-- =================================================== -->
      <!-- DOCUMENT TITLE -->
      <!-- =================================================== -->

      <div class="ecb-rv2-document-title">

        <div>

          <h3>
            Booking Registration
          </h3>

          <span>
            Booking Registration Details
          </span>

        </div>


        <div class="ecb-rv2-booking-reference">

          <small>
            Booking Reference
          </small>

          <strong>
            #{{ orderReferencePrefix }}{{
            selectedRegistration.orderId
            || selectedRegistrationOrder?.id
            }}
          </strong>

        </div>

      </div>


      <div class="ecb-rv2-title-divider"></div>


      <!-- =================================================== -->
      <!-- PARTICIPANT -->
      <!-- =================================================== -->

      <div class="ecb-rv2-participant">

        <span class="ecb-rv2-participant-number">
          1
        </span>

        <div>

          <small>
            PARTICIPANT
          </small>

          <strong>
            {{
            getRegistrationFullName(
            selectedRegistration
            )
            }}
          </strong>

        </div>

      </div>


      <!-- =================================================== -->
      <!-- COURSE -->
      <!-- =================================================== -->

      <div class="ecb-rv2-course-card">

        <small>
          SELECTED TRAINING
        </small>

        <strong>
          {{
          selectedRegistration.courseTitle
          || selectedRegistrationOrder?.shortCourseTitle
          || '-'
          }}
        </strong>

      </div>


      <!-- =================================================== -->
      <!-- PERSONAL DETAILS -->
      <!-- =================================================== -->

      <section class="ecb-rv2-section">

        <h4>
          PERSONAL DETAILS
        </h4>


        <div class="ecb-rv2-info-grid">


          <div class="ecb-rv2-info-item">

            <label>
              FIRST NAME
            </label>

            <strong>
              {{
              selectedRegistration.firstName
              || '-'
              }}
            </strong>

          </div>


          <div class="ecb-rv2-info-item">

            <label>
              LAST NAME
            </label>

            <strong>
              {{
              selectedRegistration.lastName
              || '-'
              }}
            </strong>

          </div>


          <div class="ecb-rv2-info-item">

            <label>
              DATE OF BIRTH
            </label>

            <strong>

              {{
              selectedRegistration.dateOfBirth
              ? (
              selectedRegistration.dateOfBirth
              | date:'dd/MM/yyyy'
              )
              : '-'
              }}

            </strong>

          </div>


          <div class="ecb-rv2-info-item">

            <label>
              EMAIL ADDRESS
            </label>

            <strong>
              {{
              selectedRegistration.emailAddress
              || '-'
              }}
            </strong>

          </div>


          <div class="ecb-rv2-info-item">

            <label>
              MOBILE NUMBER
            </label>

            <strong>
              {{
              selectedRegistration.mobileNumber
              || '-'
              }}
            </strong>

          </div>


          <div class="ecb-rv2-info-item">

            <label>
              ADDRESS
            </label>

            <strong>
              {{
              selectedRegistration.address
              || '-'
              }}
            </strong>

          </div>


        </div>

      </section>


      <!-- =================================================== -->
      <!-- EDUCATION -->
      <!-- =================================================== -->

      <section class="ecb-rv2-section">

        <h4>
          EDUCATION
        </h4>


        <div class="ecb-rv2-info-grid">


          <div class="ecb-rv2-info-item">

            <label>
              EDUCATION
            </label>

            <strong>
              {{
              selectedRegistration.qualificationName
              || '-'
              }}
            </strong>

          </div>


          <div class="ecb-rv2-info-item">

            <label>
              USI
            </label>

            <strong>
              {{
              selectedRegistration.usi
              || '-'
              }}
            </strong>

          </div>


        </div>

      </section>


      <!-- =================================================== -->
      <!-- QUALIFICATION CERTIFICATES -->
      <!-- =================================================== -->

      <section class="ecb-rv2-section" *ngIf="
          selectedRegistration
            .qualificationCertificates
            ?.length > 0
        ">

        <h4>
          QUALIFICATION CERTIFICATES
        </h4>


        <div class="ecb-rv2-document-card" *ngFor="
            let certificate
            of selectedRegistration
              .qualificationCertificates;

            let certificateIndex =
              index
          ">


          <div class="ecb-rv2-document-card-header">

            <div>

              <i class="bi bi-file-earmark-text"></i>

              <strong>
                Certificate Document
                {{ certificateIndex + 1 }}
              </strong>

            </div>


            <a [href]="certificate.fileUrl" target="_blank" rel="noopener noreferrer">

              Open Original

              <i class="bi bi-box-arrow-up-right"></i>

            </a>

          </div>


          <div class="ecb-rv2-image-preview" *ngIf="
              isRegistrationImageFile(
                certificate.fileUrl
              )
            ">

            <img [src]="certificate.fileUrl" [alt]="
                certificate.fileName
                || 'Certificate document'
              ">

          </div>


          <div class="ecb-rv2-pdf-preview" *ngIf="
              isRegistrationPdfFile(
                certificate.fileUrl
              )
            ">

            <i class="bi bi-file-earmark-pdf"></i>

            <div>

              <strong>
                PDF Certificate
              </strong>

              <span>
                {{
                certificate.fileName
                || 'Certificate document'
                }}
              </span>

            </div>

          </div>


          <div class="ecb-rv2-file-name">

            <i class="bi bi-paperclip"></i>

            {{
            certificate.fileName
            || 'Certificate document'
            }}

          </div>

        </div>

      </section>


      <!-- Empty certificate state -->

      <section class="ecb-rv2-section" *ngIf="
          !selectedRegistration
            .qualificationCertificates
            ?.length
        ">

        <h4>
          QUALIFICATION CERTIFICATES
        </h4>

        <div class="ecb-rv2-empty">
          No qualification certificates were uploaded.
        </div>

      </section>


      <!-- =================================================== -->
      <!-- ID DOCUMENTS -->
      <!-- =================================================== -->

      <section class="ecb-rv2-section" *ngIf="
          selectedRegistration
            .idDocuments
            ?.length > 0
        ">

        <h4>
          ID DOCUMENTS
        </h4>


        <div class="ecb-rv2-document-card" *ngFor="
            let document
            of selectedRegistration
              .idDocuments;

            let documentIndex =
              index
          ">


          <div class="ecb-rv2-document-card-header">

            <div>

              <i class="bi bi-person-vcard"></i>

              <strong>
                ID Document
                {{ documentIndex + 1 }}
              </strong>

              <span class="ecb-rv2-id-type">
                {{
                formatRegistrationIdType(
                document.idType
                )
                }}
              </span>

            </div>


            <a [href]="document.fileUrl" target="_blank" rel="noopener noreferrer">

              Open Original

              <i class="bi bi-box-arrow-up-right"></i>

            </a>

          </div>


          <div class="ecb-rv2-image-preview" *ngIf="
              isRegistrationImageFile(
                document.fileUrl
              )
            ">

            <img [src]="document.fileUrl" [alt]="
                document.fileName
                || 'ID document'
              ">

          </div>


          <div class="ecb-rv2-pdf-preview" *ngIf="
              isRegistrationPdfFile(
                document.fileUrl
              )
            ">

            <i class="bi bi-file-earmark-pdf"></i>

            <div>

              <strong>
                PDF ID Document
              </strong>

              <span>
                {{
                document.fileName
                || 'ID document'
                }}
              </span>

            </div>

          </div>


          <div class="ecb-rv2-file-name">

            <i class="bi bi-paperclip"></i>

            {{
            document.fileName
            || 'ID document'
            }}

          </div>

        </div>

      </section>


      <!-- Empty ID state -->

      <section class="ecb-rv2-section" *ngIf="
          !selectedRegistration
            .idDocuments
            ?.length
        ">

        <h4>
          ID DOCUMENTS
        </h4>

        <div class="ecb-rv2-empty">
          No identity documents were uploaded.
        </div>

      </section>


      <!-- =================================================== -->
      <!-- SUBMITTED DATE -->
      <!-- =================================================== -->

      <section class="ecb-rv2-section">

        <h4>
          SUBMISSION
        </h4>


        <div class="ecb-rv2-info-grid">

          <div class="ecb-rv2-info-item">

            <label>
              SUBMITTED DATE
            </label>

            <strong>

              {{
              selectedRegistration.submittedDate
              ? (
              selectedRegistration.submittedDate
              | date:'dd/MM/yyyy'
              )
              : '-'
              }}

            </strong>

          </div>


          <div class="ecb-rv2-info-item">

            <label>
              PAYMENT STATUS
            </label>

            <strong>
              {{
              selectedRegistrationOrder?.paymentStatus
              || '-'
              }}
            </strong>

          </div>

        </div>

      </section>


    </div>

  </div>

</p-dialog>